import { useState, useMemo } from 'react';
import { useGT } from 'gt-react';
import { useListAgentDefinitions } from 'src/api/rpc/hooks/agent-definitions/useAgentDefinitions';
import { Combobox } from '@/components/ui/combobox';
import { pickerLabels } from '@/components/common/inputs/pickerLabels';

interface AgentOption {
  id: string;
  name: string;
}

export function BackgroundAgentAutocomplete({
  agentDefinitionId,
  onSelect,
  className,
  disabled,
}: {
  agentDefinitionId: string | undefined;
  onSelect: (agentDefinitionId: string | undefined) => void;
  className?: string;
  disabled?: boolean;
}) {
  const gt = useGT();
  const [search, setSearch] = useState('');
  const { data, isLoading } = useListAgentDefinitions({ limit: 200 });

  const options: AgentOption[] = useMemo(() => {
    return (data?.definitions ?? []).map((d) => ({ id: d.id, name: d.name }));
  }, [data]);

  return (
    <Combobox
      items={options}
      value={agentDefinitionId || null}
      onValueChange={(next) => onSelect(next ?? '')}
      deselectable
      getValue={(agent) => agent.id}
      getLabel={(agent) => agent.name}
      search={search}
      onSearchChange={setSearch}
      resetSearchOnClose={false}
      disabled={disabled || isLoading}
      className={className}
      contentClassName="w-full"
      labels={pickerLabels({
        placeholder: gt('Search agents...', {
          context: 'background agent autocomplete placeholder',
        }),
        search: gt('Search options...', {
          context: 'search box placeholder inside a picker dropdown',
        }),
      })}
    />
  );
}
